const news = {
    "221": {
        "id": "221",
        "description": "Feed the Future has quickly adapted innovations like Scientific Animations Without Borders, a platform that delivers educational animated videos, for the COVID-19 crisis.",
        "image": "Agricultural Research Responses in Times of Crisis_600x400.jpg",
        "link": "https://www.feedthefuture.gov/article/agricultural-research-responses-in-times-of-crisis/",
        "source": "Feed the Future",
        "title": "Agricultural Research Responses in Times of Crisis",
        "videoLink": null,
        "date": {
            "year": "2020",
            "month": "06",
            "day": "25"
        }
    }
    /*"2": {
        "id": "2",
        "title": "Animation for Dengue Outbreak in Tonga",
        "description": "Earlier this year, Tonga declared a dengue fever outbreak after reporting several cases in the first two months of 2015. The Ministry of Health in Tonga and SAWBO worked closely together to find a quick and easy way to spread information that could help the population there learn how to deal with and prevent spreading the virus.",
        "category": "Video Coverage",
        "link": "",
        "source": "SAWBO",
        "videoLink": "//www.youtube.com/embed/bfjWLjNneFY",
        "archive": false,
        "image": "Animation for Dengue Outbreak in Tonga_media.jpg",
        "date": {
            "year": "2015",
            "month": "06",
            "day": "24"
        }
    }*/
}

const presentations = {
    "14": {
        "category": "Presentations",
        "description": "Presentation about raising mass awareness through partnerships and SAWBO",
        "file": "200715 SAWBO FAW BD.pptx",
        "id": "14",
        "image": "faw_presentation_thumbnail.jpg",
        "source": "Timothy J. Krupnik, CIMMYT",
        "title": "Scaling-out awareness of Fall Armyworm IPM: Experiences in Bangladesh with SAWBO"
    },
    "15": {
        "category": "Presentations",
        "description": "Presentation about the new SAWBO RAPID Program.",
        "file": "SAWBO_Missions_July_15_2020_FINAL.pptx",
        "id": "15",
        "image": "sawbo_rapid_presentation_thumbnail.jpg",
        "source": "SAWBO",
        "title": "Feed The Future SAWBO RAPID"
    }
}

const videos = {
    "944": {
        "id": "944",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Asante Twi",
        "country": "Ghana",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/zmbP6MuLQnk",
        "filename": "AKA_Asante Twi_Ghana_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-09 04:57:44"
    },
    /*"948": {
        "id": "948",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Bamanankan",
        "country": "Mali",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/SIoDgVfM2bU",
        "filename": "BA_Bamanankan_Mali_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-11 09:19:14"
    },*/
    "949": {
        "id": "949",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Bengali",
        "country": "Bangladesh",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/Y_Uk7ocqN9Q",
        "filename": "BEN_Bengali_Bangladesh_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-11 09:47:00"
    },
    "941": {
        "id": "941",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Dagbani",
        "country": "Ghana",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/uc0oYL04KWk",
        "filename": "DAG_Dagbani_Ghana_PHLJerrycan_Final1",
        "files": [],
        "publishDate": "2020-08-06 10:02:32"
    },
    "945": {
        "id": "945",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Dangme",
        "country": "Ghana",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/0EmqNfE_zdg",
        "filename": "ADA_Dangme_Ghana_PHLJerrycan_Final",
        "files": [],
        "publishDate": "2020-08-09 05:09:32"
    },
    "946": {
        "id": "946",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "English",
        "country": "Ghana",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/0EmqNfE_zdg",
        "filename": "EN10_English_Ghana_PHLJerryCan_covid_Final",
        "files": [],
        "publishDate": "2020-08-09 16:58:47"
    },
    "947": {
        "id": "947",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Fante",
        "country": "Ghana",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/cPHjMaZZtk0",
        "filename": "AKA1_Fante_Ghana_PHLJerryCan_covid_Final",
        "files": [],
        "publishDate": "2020-08-09 17:03:38"
    },
    /*"950": {
        "id": "950",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Fon",
        "country": "Benin",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/DN4Sz4_J84Y",
        "filename": "FON_Fon_Benin_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-11 09:56:20"
    },
    "952": {
        "id": "952",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Italian",
        "country": "Italy",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/Lv0bPB6vCkQ",
        "filename": "IT_Italian_Italy_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-12 17:10:08"
    },
    "953": {
        "id": "953",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Kannada",
        "country": "India",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/ejgw55Q4P0c",
        "filename": "KN_Kannada_India_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-12 17:15:02"
    },
    "954": {
        "id": "954",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Portuguese",
        "country": "Mozambique",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/vf5iFhifRbg",
        "filename": "PT2_Portuguese_Mozambique_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-13 12:50:21"
    },
    "951": {
        "id": "951",
        "topic": "PHLJerryCanFTF",
        "category": "Agriculture",
        "language": "Spanish",
        "country": "Venezuela",
        "subtitles": null,
        "title": "Postharvest Loss: Jerrycan Bean Storage",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "custom": null,
        "url": "//www.youtube.com/embed/dMBs7hNVIkQ",
        "filename": "ES8_Spanish_Venezuela_PHLJerrycan_covid_Final",
        "files": [],
        "publishDate": "2020-08-12 17:00:02"
    }*/
}

const topics = {
    /*"About": {
        "id": "About",
        "title": "About Scientific Animations Without Borders (SAWBO&#8482;)",
        "description": "Scientific Animations Without Borders (SAWBO&#8482;) is a University of Illinois Urbana-Champaign based initiative focused on the development of educational content for people around the planet. We create animations and place them into local languages and SAWBO&#8482; videos can be downloaded for free and used by other groups in their own local educational programs in the field. Animations are available in a variety of file formats including for cell phones.",
        "category": "SAWBO",
        "shortTitle": "About SAWBO",
        "image": "About.jpg",
        "script": true,
        "metrics": true,
        "releaseDate": "2014-01-01",
        "sdg": {
            "1": false,
            "2": false,
            "3": false,
            "4": true,
            "5": false,
            "6": false,
            "7": false,
            "8": false,
            "9": false,
            "10": true,
            "11": false,
            "12": false,
            "13": false,
            "14": false,
            "15": false,
            "16": false,
            "17": false
        },
        "videos": [1, 4]
    },
    "Neem": {
        "id": "Neem",
        "title": "Natural Insecticide from Neem Seeds",
        "description": "Naturally occurring insecticidal compounds can be extracted from neem seeds and sprayed onto crops to prevent pest insect damage. This animation explains how to sort neem fruits, dry them, remove their outer shells, sort the seeds, grind them, mix the powder in water, filter the mixture, and then prepare the solution necessary for spraying on the crops.",
        "category": "Agriculture",
        "shortTitle": "Natural Insecticide from Neem",
        "image": "Neem.jpg",
        "script": true,
        "metrics": true,
        "releaseDate": "2014-01-01",
        "sdg": {
            "1": true,
            "2": true,
            "3": false,
            "4": true,
            "5": false,
            "6": false,
            "7": false,
            "8": false,
            "9": false,
            "10": true,
            "11": false,
            "12": true,
            "13": false,
            "14": false,
            "15": true,
            "16": false,
            "17": false
        },
        "videos": [151]
    },
    "Ad-C_General": {
        "id": "Ad-C_General",
        "title": "SAWBO: Scientific Animations Without Borders",
        "description": "This video is a short explanation of how SAWBO improves people's lives through spreading knowledge. It focuses on how we spread knowledge about women's empowerment issues.",
        "category": "SAWBO",
        "shortTitle": "",
        "image": "Ad-C_General.jpg",
        "script": false,
        "metrics": true,
        "releaseDate": "",
        "sdg": {
            "1": false,
            "2": false,
            "3": false,
            "4": false,
            "5": false,
            "6": false,
            "7": false,
            "8": false,
            "9": false,
            "10": false,
            "11": false,
            "12": false,
            "13": false,
            "14": false,
            "15": false,
            "16": false,
            "17": false
        },
        "videos": [433]
    },
    "NEWSVideo_DengueTonga": {
        "id": "NEWSVideo_DengueTonga",
        "title": "Animation for Dengue Outbreak in Tonga",
        "description": "In February 2015, a dengue fever outbreak was declared in Tonga. Working with the Ministry of Health of Tonga, SAWBO took a Dengue Prevention animation that already existed in their video library and adapted it to apply to the Dengue outbreak.",
        "category": "SAWBO",
        "shortTitle": "",
        "image": "NEWSVideo_DengueTonga.jpg",
        "script": false,
        "metrics": true,
        "releaseDate": "",
        "sdg": {
            "1": false,
            "2": false,
            "3": false,
            "4": false,
            "5": false,
            "6": false,
            "7": false,
            "8": false,
            "9": false,
            "10": false,
            "11": false,
            "12": false,
            "13": false,
            "14": false,
            "15": false,
            "16": false,
            "17": false
        },
        "videos": [438]
    },
    "AndroidAppUse": {
        "id": "AndroidAppUse",
        "title": "How to Use the SAWBO Deployer App",
        "description": "This animation explains how someone can use the SAWBO Deployer app to spread knowledge to people in developing nations. This animation talks about all of the features of our app and shows examples of how it can be used in the field.",
        "category": "SAWBO",
        "shortTitle": "",
        "image": "AndroidAppUse.jpg",
        "script": false,
        "metrics": true,
        "releaseDate": "",
        "sdg": {
            "1": false,
            "2": false,
            "3": false,
            "4": false,
            "5": false,
            "6": false,
            "7": false,
            "8": false,
            "9": false,
            "10": false,
            "11": false,
            "12": false,
            "13": false,
            "14": false,
            "15": false,
            "16": false,
            "17": false
        },
        "videos": [619]
    },*/
    "PHLJerryCanFTF": {
        "id": "PHLJerryCanFTF",
        "title": "Postharvest Loss: Jerrycan Bean Storage (FTF)",
        "description": "This animation explains how to avoid insect damage when storing beans after harvest using the jerrycan method. Beans can be stored in an airtight jerrycan for long periods of time safely. The jerrycan being used must be completely clean and free of any contaminants. It can never have been used for any hazardous materials such as fuel or pesticides.",
        "category": "Agriculture",
        "shortTitle": null,
        "image": "PHLJerryCan.jpg",
        "script": null,
        "metrics": null,
        "releaseDate": "2020-08-07",
        "sdg": {
            "1": true,
            "2": true,
            "3": false,
            "4": true,
            "5": false,
            "6": false,
            "7": false,
            "8": false,
            "9": false,
            "10": true,
            "11": false,
            "12": true,
            "13": false,
            "14": false,
            "15": true,
            "16": false,
            "17": false
        },
        "videos": [
            944,
            949,
            941,
            945,
            946,
            947
        ]
    }
}

export default {
    news,
    presentations,
    videos,
    topics
}